module.exports = __webpack_public_path__ + "img/cb481f7.jpeg";